module.exports = {
  'listBandwidthPackages': '/api/cps/listBandwidthPackages',
};



// WEBPACK FOOTER //
// ./src/api/sbw/list/config.js